import { render } from "./HomeView.vue?vue&type=template&id=55da8ce9&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=55da8ce9&lang=less&scoped=true"

import exportComponent from "D:\\projects\\sales-workbench-front1\\sales-workbench-front\\sales-workbench-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55da8ce9"]])

export default __exports__